import ReactECharts from 'echarts-for-react';
import React from 'react';
import styled from 'styled-components';

import * as COLORS from '~/colors';
import { media } from '~/utils';

export default function ({ communityMembers }) {
  const data = communityMembers.slice(0, 3);

  const option = {
    tooltip: {
      trigger: 'item',
    },
    color: COLORS.chart,
    series: [
      {
        name: '既存コミュニティ',
        type: 'pie',
        radius: ['58%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 3,
        },
        emphasis: {
          label: {
            show: false,
          },
        },
        labelLine: {
          show: false,
        },
        data,
      },
    ],
  };

  return (
    <Wrapper>
      <Title>既存コミュニティ</Title>
      <Main>
        <ChartArea>
          <ReactECharts option={option} opts={{ height: '200px' }} />
        </ChartArea>
        <Members>
          {data.map((cm, i) => (
            <Member key={i}>
              <Color color={COLORS.chart[i]} />
              <MemberText>{`${cm.name}\n${cm.value}人`}</MemberText>
            </Member>
          ))}
        </Members>
      </Main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  ${media.mid`
    height: auto;
  `}
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Main = styled.div`
  display: flex;
  flex-direction: row;

  ${media.mid`
    flex-direction: column;
  `}
`;

const ChartArea = styled.div`
  width: 50%;
  height: 200px;

  ${media.mid`
    width: 100%;
  `}
`;

const Members = styled.div`
  padding: 20px 35px 40px;
  border-left: 1px solid #d6d9dc;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.mid`
    border-left: none;
    border-top: 1px solid #D6D9DC;
  `}
`;

const Member = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  position: relative;
`;

const Color = styled.div`
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: ${(props) => props.color};
`;

const MemberText = styled.div`
  margin-left: 10px;
  white-space: pre-wrap;
  font-size: 16px;
  line-height: 25px;
  color: #505050;
  position: relative;
  top: -8px;
`;
